import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect, useDispatch, useSelector } from 'react-redux';

import { getI18n } from '../../../../AppReducer';
import withParams from '../../../../util/withParams';
import Spinner from '../../../App/components/Spinner/Spinner';

import { deleteResponse, fetchResponse, fetchTags, setTags } from '../../ResponseActions';
import { getAllTags, getFetchError, getResponse, isResponseLoaded } from '../../ResponseReducer';

import ResponsePage from './ResponsePage';

function ResponsePageContainer(props) {
  const {
    params: { surveyId, responseId },
  } = props;
  const dispatch = useDispatch();
  const allTags = useSelector(getAllTags);
  const loaded = useSelector(isResponseLoaded(responseId));

  useEffect(() => {
    if (!allTags) {
      dispatch(fetchTags(null, surveyId));
    }
    if (!loaded) {
      dispatch(fetchResponse(null, surveyId, responseId));
    }
  }, [surveyId, responseId, allTags, loaded, dispatch]);

  if (props.response) {
    return <ResponsePage {...props} />;
  }
  return <Spinner />;
}

ResponsePageContainer.propTypes = {
  params: PropTypes.object.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  let allTags = getAllTags(state);
  allTags = allTags?.map(tag =>
    Object.prototype.hasOwnProperty.call(tag, 'name') ? tag.name : tag,
  );
  return {
    allTags,
    response: getResponse(ownProps.params.responseId)(state),
    tags: getResponse(ownProps.params.responseId)(state)
      ? getResponse(ownProps.params.responseId)(state).tags || []
      : [],
    locale: getI18n(state).locale,
    fetchError: getFetchError(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    deleteResponse: (_, surveyId, responseId, cb) => {
      dispatch(deleteResponse(null, surveyId, responseId, cb));
    },
    setTags: (_, surveyId, responseId, tags) => {
      dispatch(setTags(null, surveyId, responseId, tags));
    },
  };
};

export default withParams(
  connect(mapStateToProps, mapDispatchToProps)(injectIntl(ResponsePageContainer)),
);
